import { Button, Card, CardHeader, Stack, TextField } from '@mui/material';
import { Formik } from 'formik';
import { auth, googleProvider } from '../../firebase';
import { useNavigate } from 'react-router';
import {
  useCreateUserWithEmailAndPassword,
  useSignInWithPopup,
} from '../../api/hooks/auth';

const Signup = () => {
  const navigate = useNavigate();

  const { mutate: signup } = useCreateUserWithEmailAndPassword(auth, {
    onSuccess() {
      navigate('/products');
    },
    onError() {
      console.error('Could not sign you in!');
    },
  });

  const handleSignupWithPassword = (values: {
    email: string;
    password: string;
  }) => signup(values);

  const { mutate: signInWithPopUp } = useSignInWithPopup(auth, {
    onSuccess() {
      navigate('/products');
    },
    onError() {
      console.error('Could not sign you in!');
    },
  });

  const signInWithGoogle = () => signInWithPopUp({ provider: googleProvider });

  return (
    <Card elevation={7} sx={{ mx: 'auto', mt: 10, p: 5, width: 400 }}>
      <CardHeader title="Signup" />
      <Stack>
        <Formik
          initialValues={{
            email: '',
            password: '',
          }}
          onSubmit={handleSignupWithPassword}
        >
          {({ submitForm, getFieldProps }) => (
            <Stack component="form" alignItems="center">
              <TextField
                type="email"
                label="Email"
                {...getFieldProps('email')}
                sx={{ m: 1, width: '100%' }}
              />
              <TextField
                type="password"
                label="Password"
                {...getFieldProps('password')}
                sx={{ m: 1, width: '100%' }}
              />
              <Button
                variant="contained"
                fullWidth
                onClick={submitForm}
                sx={{ mb: 1 }}
              >
                Signup
              </Button>
            </Stack>
          )}
        </Formik>
        <Button variant="contained" color="error" onClick={signInWithGoogle}>
          Sign in with Google
        </Button>
        <Button onClick={() => navigate('/login')} sx={{ m: 1 }}>
          Have an account? Login
        </Button>
      </Stack>
    </Card>
  );
};

export default Signup;
